/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Mv3Inputs */

const en_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const ar_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const bn_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const de_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const es_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const fr_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const pt_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const zh_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const tr_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const ru_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

const pl_svchip_mv3 = /** @type {(inputs: Svchip_Mv3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MV3`)
};

/**
* | output |
* | --- |
* | "MV3" |
*
* @param {Svchip_Mv3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_mv3 = /** @type {((inputs?: Svchip_Mv3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Mv3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_mv3(inputs)
	if (locale === "bn") return bn_svchip_mv3(inputs)
	if (locale === "de") return de_svchip_mv3(inputs)
	if (locale === "es") return es_svchip_mv3(inputs)
	if (locale === "fr") return fr_svchip_mv3(inputs)
	if (locale === "pt") return pt_svchip_mv3(inputs)
	if (locale === "zh") return zh_svchip_mv3(inputs)
	if (locale === "tr") return tr_svchip_mv3(inputs)
	if (locale === "ru") return ru_svchip_mv3(inputs)
	if (locale === "pl") return pl_svchip_mv3(inputs)
	return en_svchip_mv3(inputs)
});